import axios from 'axios';

const API_TOKEN = 'xoxb-3470542383745-3489847144868-HyKBb1QKv6QNPLrKxMu3Bd3C';
const WEBHOOK_URL = 'https://hooks.slack.com/services/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';

function initSlack(){
    console.log(navigator);

    window.onerror = (msg, src, lineno, colno, error) => {

        const details = `oscpu, platform : [${navigator.oscpu}][${navigator.platform}]\nuserAgent : ${navigator.userAgent}`
            + `\nsrc : ${src} [${lineno}:${colno}]\ndetails : ${error}`;
            
        send(msg, details);
    }
}

const send = async (title, message) => {

    const payload = {
        channel:'error',
        token:API_TOKEN,
        blocks:[
            {
                type:'header',
                text:{
                    type:'plain_text',
                    text:title,
                }
            },
            {
                type:'section',
                text:{
                    type:'plain_text',
                    text:message,
                }
            },
        ]
    };

    const result = await axios.post(WEBHOOK_URL, payload, {
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: "application/json",
        }
    });

    console.log(result);
};

export {initSlack};